/**
 * Created by Pankaj on 04-Nov-2019
 */
import {SymbolIdleAnimationController} from "@nolimitcity/slot-game/bin/game/idleanimation/symbolidleanimation/SymbolIdleAnimationController";
import {Timeline} from "gsap";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {ISymbolNewStateTransitionConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {RomanEmpireGameConfig} from "../RomanEmpireGameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {RomanEmpireParsedGameData} from "../server/data/RomanEmpireParsedGameData";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {RomanEmpireGameModuleConfig} from "../RomanEmpireGameModuleConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {RomanEmpireReelSymbol} from "../symbols/RomanEmpireReelSymbol";

export class RESymbolIdleAnimationController extends SymbolIdleAnimationController {
    private _layer: ScalableLayer;
    private reelId: number;
    private _isBothWaysWinPresent: boolean = false;
    private _playIdleAnimation: boolean = true;

    constructor() {
        super({
            minInterval: 3,
            maxInterval: 5
        });
        this._layer = StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.SYMBOLS_IDLE.name);
    }

    protected addEventListeners(): void {
        super.addEventListeners();
        // added below DIALOG EVENTS TO FIXED #187
        NolimitApplication.events.on(NolimitApplication.DIALOG_OPENED, () => {
            this._playIdleAnimation = false
        });
        NolimitApplication.events.on(NolimitApplication.DIALOG_CLOSING, () => {
            this._playIdleAnimation = true
        });

    }

    protected hasWin(): boolean {
        return (this._betWinsData != null && this._betWinsData.length > 0 || this._isBothWaysWinPresent);
    }

    protected onGameDataParsed(data: RomanEmpireParsedGameData) {
        this._isBothWaysWinPresent = data.bothWayWins.length > 0;
        this._betWinsData = data.betWins;
    }


    protected playIdleAnimation(): void {
        if (!this._hasSymbolIdle|| !this._playIdleAnimation) {
            return;
        }

        const reelId: number = MathHelper.randomNumberInRange(0, RomanEmpireGameConfig.instance.REELS_NUM - 1);
        const symbolId: number = MathHelper.randomNumberInRange(0, RomanEmpireGameConfig.instance.SYMBOLS_NUM_PER_REEL - 1);
        const symbol = Reels.getSymbol(reelId, symbolId);
        this.reelId = reelId;
        if (symbol) {
            RomanEmpireGameModuleConfig.scatterAnim.hideScatterAnimation();
            this.playSymbolIdleAnimation(symbol);
            if (symbol.symName !== "S") {
                if (RomanEmpireGameConfig.instance.SYMBOLS_WITH_WIN_SPINE.indexOf(symbol.symName) !== -1) {
                    RomanEmpireReelSymbol._isIdleAnimation=true;
                    symbol.changeState({
                        state: RomanEmpireGameConfig.instance.SYMBOL_STATES.initialWin,
                        fadeInDuration: 0,
                    });
                } else {
                    const symbolAnimation: Timeline = RomanEmpireGameModuleConfig.foregroundAnimation.getSymbolAnimShow(reelId, symbolId, symbol);
                    symbolAnimation.play(0);
                }
            } else {
                RomanEmpireGameModuleConfig.scatterAnim.playScatterIdleAnimation({reelId, symbolId});
            }
        }
    }


    protected playSymbolIdleAnimation(symbol: StateReelSymbol) {
        let symState = RomanEmpireGameConfig.instance.SYMBOL_STATES.idle;
        symbol.changeState(<ISymbolNewStateTransitionConfig>{
            state: symState,
            replay: false
        });
    }


}